module.exports = __webpack_public_path__ + "static/fonts/MyriadPro-BlackCond.93bcd34.eot";